export const build = {"tag":"v1.0.7","hash":"41a075f1","time":"261103.0823"}